<div class="w-full h-full flex justify-center items-center px-4 py-8">
  <div class="w-full max-w-md border border-white/15 rounded-xl bg-[#0b1230]/80 p-6 sm:p-8 shadow-xl">
    <h2 class="text-white text-xl font-semibold">Design Partner Login</h2>
    <p class="text-sm text-white/70 mt-2 mb-6">
      Sign in to your design partner account.
    </p>

    <form (ngSubmit)="login()" class="space-y-4">
      <div>
        <label class="text-white/80 text-sm block mb-1">Email</label>
        <input
          type="email"
          name="email"
          [(ngModel)]="email"
          class="w-full bg-transparent text-white border rounded-md px-3 py-2 outline-none"
          [ngClass]="hasError('email') ? 'border-red-500' : 'border-white/20'"
          placeholder="Enter work email"
        />
      </div>

      <div>
        <label class="text-white/80 text-sm block mb-1">Password</label>
        <div
          class="flex items-center border rounded-md px-3 py-2"
          [ngClass]="hasError('password') ? 'border-red-500' : 'border-white/20'"
        >
          <input
            type="password"
            name="password"
            [(ngModel)]="password"
            class="w-full bg-transparent text-white outline-none"
            #passwordInput
            placeholder="Enter password"
          />
          <button
            type="button"
            class="text-white/70 hover:text-white ml-2"
            (click)="togglePasswordVisibility(passwordInput)"
          >
            <i *ngIf="!showPassword" class="fas fa-eye-slash"></i>
            <i *ngIf="showPassword" class="fas fa-eye"></i>
          </button>
        </div>
      </div>

      <div class="text-right">
        <button
          type="button"
          class="text-sm text-[#9ed3ff] hover:text-[#31a1f6] transition-colors"
          (click)="navigateToForgotPassword()"
        >
          Forgot password?
        </button>
      </div>

      <button
        type="submit"
        [disabled]="isSubmitting"
        class="w-full h-11 bg-[#31a1f6] text-white rounded-md font-medium hover:bg-[#2387d6] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {{ isSubmitting ? 'Signing in...' : 'Sign In' }}
      </button>

      <button
        type="button"
        (click)="navigateToRegister()"
        class="w-full text-sm text-[#9ed3ff] hover:text-[#31a1f6] transition-colors"
      >
        New design partner? <span class="underline">Register here</span>
      </button>

      <button
        type="button"
        (click)="navigateToUserLogin()"
        class="w-full text-sm text-white/60 hover:text-white/80 transition-colors"
      >
        Sign in as a regular user
      </button>
    </form>
  </div>
</div>
